import React from 'react'
import { checkStatus } from 'shared/helpers/checkStatus'
import { path, prop } from 'ramda'
import moment from 'moment'
import { storage } from 'shared/helpers/user'

class Results extends React.Component {
  componentDidMount () {
    const userId = storage.getId()
    const userToken = storage.getToken()
    const authHeader = `${userId}:${userToken}`
    const params = path(['match', 'params'], this.props)
    const timeSlotInfoUrl = this.props.forPreview
      ? `/v1/research/preview/timeslot/${params.timeSlotHash}`
      : `/v1/research/project/${params.projectId}/${params.timeSlotId}`
    const transcriptFilename = this.props.forPreview
      ? `/v1/transcript/preview/${params.timeSlotHash}`
      : `/v1/transcript/${params.timeSlotId}`
    return Promise.all([
      fetch(timeSlotInfoUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'IC-Auth': authHeader,
        },
      })
      .then(checkStatus)
      .then(res => res.json()),
      fetch(transcriptFilename, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'IC-Auth': authHeader,
        },
      })
      .then(checkStatus)
      .then(res => res.text())
      .catch(() => {
        console.log('no transcript')
      }),
    ]).then(([timeSlotInfo, transcript = 'Processing Transcription...']) => {
      this.props.updateState({
        [params.timeSlotId]: {
          ...timeSlotInfo.interviewee,
          projectName: timeSlotInfo.projectName,
          transcript,
          fetched: true,
          transcriptFilename,
        },
      })
    })
  }

  showModal = () => {
    this.props.openModal({
      projectOrTimeslotUrl: `${window.location.origin}/qual/preview/interview/${this.props.shareHash}`,
      timeSlotId: this.props.timeSlotId,
      projectId: this.props.projectId,
    })
  }

  renderSideBar = () =>
    <div className="side-user-content">
      <h3>
        {this.props.userId}
      </h3>
      <div className="crowd">
        <h3>Crowd</h3>
        <span>
          {' '} - {this.props.crowd}
        </span>
      </div>
      <div className="date">
        {moment(this.props.interviewDate).locale('en').format('MMMM Do YYYY, h:mma')}
      </div>
      <div className="options">
        <div onClick={this.showModal} className="item">
          Share
          <i className="im-ss-navigateright" />
        </div>
        {this.props.deliverableUrls.map((d, i) =>
          <div>
            <a className="item" href={d.recordingUrl} target="_blank" rel="noopener noreferrer">
              {`Download Recording${i ? ` ${i + 1}` : ''}`}
              <i className="im-ss-navigateright" />
            </a>
          </div>
        )}
        {this.props.transcriptsRequested && path([0, 'transcriptUrl'], this.props.deliverableUrls) && <div>
          <a className="item" href={`/v1/transcript/${this.props.timeSlotId}`} download>
            Download Transcript
            <i className="im-ss-navigateright" />
          </a>
        </div>}
      </div>
    </div>

  renderTopBar = () =>
    <div className="top-user-content">
      <div>
        <h3>
          {this.props.userId}
        </h3>
        <div className="crowd">
          <h3>Crowd</h3>
          <span>
            {' '}- {this.props.crowd}
          </span>
        </div>
      </div>
      <div className="date">
        {moment(this.props.interviewDate).locale('en').format('MMMM Do YYYY, h:mma')}
      </div>
    </div>

  render () {
    if (!this.props.fetched) return null
    const [first, ...rest] = this.props.deliverableUrls.map(prop('recordingUrl'))
    return (
      <div className={`user-container ${this.props.forPreview ? 'preview' : ''}`}>
        <div className="main-user-content">
          {this.props.forPreview ? this.renderTopBar() : null}
          <div className="recording-container">
            <i className="incrowd-logo" />
            <video controls key={first}>
              <source src={first} />
              Your browser does not support the audio element.
            </video>
          </div>
          {rest.map((r, i) =>
            <div className="other-audio-controls">
              <div className="recording-title">Recording {i + 2}</div>
              <video className="recording" key={i} controls>
                <source src={r} />
                Your browser does not support the audio element.
              </video>
              <br />
            </div>
          )}
          {this.props.transcriptsRequested && <div className="transcript-container">
            <div className="transcript-header">
              Transcript
              <i className="im-ss-navigatedown" />
            </div>
            <div className="transcript-box">
              {this.props.transcript}
            </div>
          </div>}
        </div>
        {!this.props.forPreview && this.renderSideBar()}
      </div>
    )
  }
}

export default Results
